const breakpoints = {
  sm: 640,
  md: 865,
  lg: 975, //Set to match Gin toolbar
  xl: 1248,
  "2xl": 2100,
};

const breakpointsWithPx = {};
Object.keys(breakpoints).map((key) => {
  breakpointsWithPx[key] = `${breakpoints[key]}px`;
});

module.exports = {
  Breakpoints: breakpoints,
  BreakpointsWithPx: breakpointsWithPx,
};
